import { createClient } from '@supabase/supabase-js';
import { SUPABASE_KEY, SUPABASE_URL } from './config.js';

// Com sinal fraco, um pedido pode ficar pendurado por minutos. Passado o
// prazo, ele é cancelado e o app trata como "sem sinal" (o que era para
// gravar continua na fila e vai depois; reenviar não duplica).
const PRAZO_MS = 20000;

function fetchComPrazo(recurso, opcoes = {}) {
  const controle = new AbortController();
  const tempo = setTimeout(() => controle.abort(), PRAZO_MS);
  // Quem já mandou um sinal de cancelamento continua podendo cancelar.
  if (opcoes.signal) {
    if (opcoes.signal.aborted) controle.abort();
    else opcoes.signal.addEventListener('abort', () => controle.abort(), { once: true });
  }
  return fetch(recurso, { ...opcoes, signal: controle.signal }).finally(() => clearTimeout(tempo));
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Se alguém clicar no link do e-mail em vez de digitar o código, também entra.
    detectSessionInUrl: true,
    storageKey: 'maxcargo-sessao',
  },
  global: { fetch: fetchComPrazo },
});

// Executa uma consulta e devolve os dados; se der erro, lança o erro.
export async function executar(consulta) {
  const { data, error } = await consulta;
  if (error) throw error;
  return data;
}

// Espera a promessa até `ms`; passado isso, devolve { tempo: true } (a
// promessa continua correndo por trás).
export function comPrazo(promessa, ms) {
  let relogio;
  const limite = new Promise((ok) => {
    relogio = setTimeout(() => ok({ tempo: true }), ms);
  });
  return Promise.race([promessa.then((valor) => ({ valor })), limite]).finally(() => clearTimeout(relogio));
}
